import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { VehicleGroup } from '../model/vehicle-group';
import { filter, first, map, tap } from 'rxjs/operators';
import { VehicleGroupService } from './vehicle-group.service';

@Injectable()
export class VehicleGroupsProvider {

  private groupsSubject = new BehaviorSubject<VehicleGroup[] | null>(null);
  nonNullGroups$ = this.groupsSubject.asObservable().pipe(filter(groups => groups != null), first());
  groupsWithUpdates$ = this.groupsSubject.asObservable().pipe(map(groups => groups == null ? [] : groups));

  constructor(private vehicleGroupService: VehicleGroupService) {
    this.loadData().subscribe();
  }

  loadData(): Observable<any> {
    return this.vehicleGroupService.fetchAllVehicleGroups().pipe(tap(groups => this.setVehicleGroups(groups)));
  }

  private setVehicleGroups(groups: VehicleGroup[]): void {
    this.groupsSubject.next(groups);
  }

}
